import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { QuestionnaireService } from '../../services/questionnaire.service';
import { KydRequestService } from '../../services/kyd-request.service';
import { ConnectionService } from '../../services/connection.service';
import { DistributorsService } from '../../services/distributors.service';
import { Distributor } from '../../model/distributor';
import { DcAlertService } from '../../../ui-kit/dc-alert/dc-alert.service';
import { Contact } from '../../model/contact';
import { PlatformLocation } from '@angular/common';
import { TransferService } from '../../services/transfer.service';
import { ApiService } from 'src/app/services/api.service';

interface DropdownItem {
  id: string;
  displayValue: string;
}

@Component({
    selector: 'deltacapita-create-distributor-contact',
    templateUrl: './create-distributor-contact.component.html',
    styleUrls: ['./create-distributor-contact.component.scss'],
    standalone: false
})
export class CreateDistributorContactComponent implements OnInit {
  @Input() modal: NgbModalRef;

  loading = true;
  distributorId;
  isDistributorSet = false;
  createDistributorContactForm: UntypedFormGroup;

  distributorsDropdownData: DropdownItem[];

  @ViewChild('loadingSpinner', { static: true }) loadingSpinner: TemplateRef<any>;

  constructor(
    private dataService: DataService,
    private questionnaireService: QuestionnaireService,
    private kydRequestService: KydRequestService,
    private connectionService: ConnectionService,
    private distributorsService: DistributorsService,
    private dcAlertService: DcAlertService,
    private transferService: TransferService,
    private apiService: ApiService,
    location: PlatformLocation
  ) {
    location.onPopState((event) => {
      // ensure that modal is opened
      if (this.modal !== undefined) {
        this.modal.close();
      }
    });
  }

  async ngOnInit(): Promise<void> {
    if (this.transferService.isClicked) {
      this.distributorId = this.transferService.getData() || '';
      if (this.distributorId) {
        this.isDistributorSet = true;
      }
      this.transferService.isClicked = false;
    }
    this.createDistributorContactForm = new UntypedFormGroup({
      clientid: new UntypedFormControl(this.distributorId || null, Validators.required),
      name: new UntypedFormControl(null, Validators.required),
      email: new UntypedFormControl(null, [Validators.required, Validators.email]),
      tel: new UntypedFormControl(null),
      mobile: new UntypedFormControl(null),
      region: new UntypedFormControl('EMEA', Validators.required),
    });

    this.distributorsService.getAllDistributors().subscribe((distributors: Distributor[]) => {
      this.distributorsDropdownData = this.makeDropdownItems(distributors, 'id', 'name');
      this.loading = false;
    });
  }

  async createDistributorContact(): Promise<void> {
    const newDistributorContact = this.createDistributorContactForm.getRawValue();

    const existingSearchResults = await this.apiService
      .get<any>(`ddq/distributors/contacts/by-email/${newDistributorContact.email}`)
      .toPromise();

    newDistributorContact.region = [newDistributorContact.region];

    if (existingSearchResults && Array.isArray(existingSearchResults) && existingSearchResults.length) {
      this.dcAlertService.showAlert({
        type: 'danger',
        message: 'Error adding contact, contact account with same email already exists in database.',
      });
    } else {
      this.distributorsService.addDistributorContact(newDistributorContact).subscribe((contact: Contact) => {
        this.dcAlertService.showAlert({
          type: 'success',
          message: `Successfully created new contact: ${contact.name}(${contact.email})`,
        });

        // this.distributorsService.refreshContactsSubject.next();
        this.transferService.notifyOther({ toRefresh: true, keysToRemove: ['contacts'] });

        this.modal.close();
      });
    }
  }

  makeDropdownItems(data, idField, displayValueField): DropdownItem[] {
    return data.map((dataItem) => {
      return {
        id: dataItem[idField],
        displayValue: Array.isArray(displayValueField)
          ? `${dataItem[displayValueField[0]]} (${dataItem[displayValueField[1]]})`
          : dataItem[displayValueField],
      };
    });
  }

  get distributor() {
    return this.createDistributorContactForm.controls.clientid.value[0].id;
  }
}
